import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import axios from 'axios';
import { Result } from '../types';
import { Loader, Progress } from 'semantic-ui-react';
import qs from 'qs';

const HeaderInfo = styled.div`
  font-weight: bold;
  margin-top: 8px;
  background: #f7f7f9;
  border-radius: 6px 6px 0px 0px;
  padding: 24px 16px;
  font-size: 18px;
  border-bottom: 1px solid #e5e5ea;
  width: 600px;
  display: flex;
  align-items: center;
`;
const ViewButton = styled.div`
  background-color: #333;
  color: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  margin-left: 40px;
  cursor: pointer;
`;
const DownloadButton = styled.div`
  background-color: #333;
  color: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  margin-left: 16px;
  cursor: pointer;
`;
interface Props {
  property: Result;
  location: string;
  county: string;
  swisCode: string;
}
const TaxMap = (props: Props) => {
  const [mapSource, setMapSource] = useState('');
  const [isPdf, setIsPdf] = useState(false);
  const [progress, setProgress] = useState(5);
  const [loading, setLoading] = useState(false);
  const removeLastPeriod = (str: string) => {
    if (str[str.length - 1] === '.') {
      return str.substring(0, str.length - 1);
    }
    return str;
  };

  const replaceLeadingZeros = (str: string) => {
    return str.replace(/^0+/, '');
  };

  const getBlockLotQualifierString = (block: string, lot: string, qualifier: string) => {
    const actualQualifier = qualifier ? `_${qualifier}` : '';
    return `${removeLastPeriod(block)}_${removeLastPeriod(lot)}${actualQualifier}`;
  };
  const getTaxMap = async () => {
    setLoading(true);
    const { data } = await axios.get(
      `https://njpropertyrecords.com/api/property/${props.property.swis}_${getBlockLotQualifierString(
        props.property.property.block,
        props.property.property.lot,
        props.property.property.qualifier
      )}/assets/tax-map?format=pdf&apiKey=988bb1e33286f80887ae3042689cc2f6&marker=true`,
      {
        responseType: 'arraybuffer',
      }
    );
    if (data) {
      const response = Buffer.from(data, 'binary').toString('base64');
      if (response) {
        setMapSource(base64ToUrl(response, 'image/png'));
        setIsPdf(false);
      }
    }
    setLoading(false);
  };

  const getTaxMapNyc = async () => {
    setLoading(true);
    const params = qs.stringify({
      boro: props.property.property.section,
      block: replaceLeadingZeros(props.property.property.block),
      lot: replaceLeadingZeros(props.property.property.lot),
    });
    const { data } = await axios.get(`/api/clientproperty/getNycTaxMap?${params}`);
    if (data) {
      setMapSource(base64ToUrl(data, 'application/pdf'));
    }
    setIsPdf(true);
    setLoading(false);
  };

  const getTaxMapNys = async () => {
    setLoading(true);
    const params = qs.stringify({
      county: props.county,
      section: props.property.property.section,
      block: props.property.property.block,
      lot: props.property.property.lot,
      swisCode: props.swisCode,
    });
    const { data } = await axios.get(`/api/clientproperty/getNysTaxMap?${params}`);
    if (data) {
      setMapSource(base64ToUrl(data, 'application/pdf'));
    }
    setIsPdf(true);
    setLoading(false);
  };

  function base64ToUrl(base64: string, type: string) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return URL.createObjectURL(new Blob([bytes.buffer], { type }));
  }
  useEffect(() => {
    if (props.location.toLowerCase() === 'nyc') {
      getTaxMapNyc();
    } else if (props.location.toLowerCase() === 'ny state') {
      getTaxMapNys();
    } else {
      getTaxMap();
    }
    const interval = setInterval(() => {
      setProgress(progress => {
        if (progress >= 100) {
          clearInterval(interval); // Clear the interval when progress is 100
          return progress;
        }
        return progress + 2;
      });
    }, 1000);
  }, []);

  return (
    <div style={{ width: '100%', borderRadius: 6, marginLeft: 33, marginTop: 75 }}>
      <HeaderInfo>
        <span>Tax Map</span>
        {!loading && mapSource && (
          <>
            <ViewButton>
              <a href={mapSource} target="_blank" rel="noreferrer" style={{ color: '#fff' }}>
                View
              </a>
            </ViewButton>
            <DownloadButton>
              <a href={mapSource} download style={{ color: '#fff' }}>
                Download
              </a>
            </DownloadButton>
          </>
        )}
      </HeaderInfo>
      {mapSource &&
        (isPdf ? (
          <iframe title="map" style={{ width: 600, height: 400 }} src={`${mapSource}#toolbar=0`} />
        ) : (
          <img title="map" style={{ width: 600, height: 400 }} src={`${mapSource}`} alt="" />
        ))}
      {loading ? (
        <div style={{ width: 600, height: 400, textAlign: 'center' }}>
          <Progress style={{ marginTop: '25%' }} percent={progress} indicating />
        </div>
      ) : (
        !mapSource && (
          <div style={{ height: 350, textAlign: 'center', fontSize: 18, paddingTop: '25%' }}>
            Map not found for this address.
            {props.location.toLowerCase() === 'ny state' && (
              <div style={{ marginTop: 16 }}>
                Please note, maps for some counties are not yet available for preview.
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default TaxMap;
